import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { InputWithLabel } from "../../components/micro";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { newPassword } from "../../redux/auth/slice";

const NewPassword = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <div className={`h-screen overflow-hidden relative`}>
        <div className="flex items-center justify-center h-full bg-no-repeat bg-cover bg-center opacity-95 bg-gradient-to-r from-[rgba(255,235,79,0.5)] to-[rgba(69,160,85,0.5)]">
          <section className="w-full ">
            <div className="max-w-sm w-full mx-auto">
              <div className="flex items-center justify-center text-center">
                {/* <ResetLock /> */}
              </div>
              <div className="main-view">
                <div className="my-8 text-center ">
                  <h1 className="sm:text-2xl text-4xl font-opensans font-normal mb-1">
                    Change Password
                  </h1>
                </div>
                <Formik
                  initialValues={{
                    newPassword: "",
                    confirmPassword: "",
                  }}
                  validationSchema={Yup.object({
                    newPassword: Yup.string().required(
                      "Please enter a new password"
                    ),
                    confirmPassword: Yup.string()
                      .required("Please confirm your new password")
                      .oneOf(
                        [Yup.ref("newPassword"), null],
                        "Passwords must match"
                      ),
                  })}
                  onSubmit={(values) => {
                    setLoading(true);
                    dispatch(newPassword(values)).then((res) => {
                      setLoading(false);
                      if (res.type === "newPassword/fulfilled") {
                        navigate("/success-password");
                      }
                    });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="space-y-5">
                        {/* New Password */}
                        <InputWithLabel
                          className={
                            errors.newPassword && touched.newPassword
                              ? `input-error`
                              : `border`
                          }
                          idFromName="newPassword"
                          label="New Password*"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.newPassword}
                          errors={errors.newPassword && touched.newPassword}
                          errorsText={errors.newPassword}
                        />

                        {/* Confirm New Password */}
                        <InputWithLabel
                          className={
                            errors.confirmPassword && touched.confirmPassword
                              ? `input-error`
                              : `border`
                          }
                          idFromName="confirmPassword"
                          label="Confirm New Password*"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.confirmPassword}
                          errors={
                            errors.confirmPassword && touched.confirmPassword
                          }
                          errorsText={errors.confirmPassword}
                        />

                        <button
                          type="submit"
                          className="w-full block text-white bg-themeBtn text-center text-base border-2 border-transparent uppercase rounded transition duration-500 py-2 lg:px-7 px-4"
                        >
                          {loading ? "Loading...." : "Confirm New Password"}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
